module.exports = __webpack_public_path__ + "static/media/checkedLogo.ee59a179.svg";